import { Capability } from '@mono/types/src/mds';

import { TypeKeys, WidgetBlockAction } from './types';

type SetCapabilitiesLoadedAction = WidgetBlockAction<TypeKeys.CAPABILITIES_LOADED, { data: Capability[] }>;

const setCapabilitiesLoaded = (widgetId: string | null, instanceId: string | null, data: Capability[]): SetCapabilitiesLoadedAction => ({
    type: TypeKeys.CAPABILITIES_LOADED,
    payload: {
        widgetId,
        instanceId,
        data,
    },
});

export default setCapabilitiesLoaded;
export { SetCapabilitiesLoadedAction };
